import { Directive, DirectiveBinding } from 'vue'

export type TrackDirectiveBinding = Record<string, string>

export const directives: Record<string, Directive> = {
  track: {
    beforeMount (el: HTMLElement, binding: DirectiveBinding<TrackDirectiveBinding>) {
      const { arg: label, value: extraDataset } = binding

      el.dataset.trackCategory = 'squeegee'
      el.dataset.trackLabel = label

      if (extraDataset) {
        Object.keys(extraDataset).forEach(key => {
          el.dataset[key] = extraDataset[key]
        })
      }
    }
  },
  'active-class': {
    beforeMount (el: HTMLElement | HTMLAnchorElement, binding: DirectiveBinding<string | undefined>) {
      const className = binding.value ? binding.value : 'active'

      if ('href' in el && location.href.includes(el.href)) {
        el.classList.add(className)
      }
    }
  }
}
